import { render, staticRenderFns } from "./EventDeviceData.vue?vue&type=template&id=5a527385&scoped=true&"
import script from "./EventDeviceData.vue?vue&type=script&lang=js&"
export * from "./EventDeviceData.vue?vue&type=script&lang=js&"
import style0 from "./EventDeviceData.vue?vue&type=style&index=0&id=5a527385&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a527385",
  null
  
)

export default component.exports